import Swiper from 'swiper';
import { Navigation, Autoplay, A11y } from 'swiper/modules';

export class PartnerSlider {
  constructor() {
    this.init();
  }

  init() {
    const amountOfSlides = document.querySelectorAll('.partners-slider .swiper-slide').length;
    new Swiper('.partners-slider', {
      modules: [Navigation, Autoplay, A11y],
      loop: amountOfSlides > 1,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: '.partners-button-next',
        prevEl: '.partners-button-prev',
      },
      a11y: {
        prevSlideMessage: 'Poprzedni slajd',
        nextSlideMessage: 'Następny slajd',
      },
      breakpoints: {
        768: {
          loop: amountOfSlides > 3,
          slidesPerView: 3,
        },
      },
    });
  }
}
